import { useUserInfo } from "@/api/user";

/**
 * Returns true when the current user's org is on the `enterprise` plan.
 *
 * Enterprise customers have unlimited seats and custom contracts, so they
 * shouldn't see seat-count / "seats-left" / "Add Seats" UI. They also
 * don't self-serve billing changes (plan switches, cancellation) — that
 * goes through their account manager.
 *
 * For "can self-serve billing changes" (which excludes both enterprise
 * AND beta), see {@link useIsSelfServeBilling}.
 * For beta-tier-specific UX, see `useBetaPlan`.
 */
export function useEnterprisePlan() {
  const { data: userInfo } = useUserInfo();
  return userInfo?.subscription?.plan_name === "enterprise";
}
